export default "__VITE_ASSET__CapBfwoC__"